import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { PartImagesPanel } from './PartImagesPanel';

/** Read/preview a part's images & drawings from the list (eye icon in Actions).
 *  Reuses PartImagesPanel — admins also get upload/delete here; non-admins view only. */
export function PartImagesViewerModal({ part, onClose }) {
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading text-slate-900">
            Images & Drawings — {part.part_number}
          </DialogTitle>
        </DialogHeader>
        <PartImagesPanel partId={part.part_id} />
      </DialogContent>
    </Dialog>
  );
}
